import styled from 'styled-components'
import downArrow from './down-arrow.svg'

export const Select = styled.select`
  display: block;
  width: 100%;
  height: 50px;
  border: solid 1px #bab4ce;

  padding: 15px 54px 15px 20px;
  border-radius: 3px;

  font-family: "SF Pro Display";
  font-size: 16px;
  color: #172129;
  background: white;
  line-height: 1;

  appearance: none;

  background: url(${downArrow}) no-repeat right 18px center;

  ::placeholder {
    color: #979797;
  }

  :hover, :focus {
    box-shadow: 0 16px 80px 0 rgba(93, 101, 207, 0.08), 0 8px 40px 0 rgba(79, 85, 217, 0.09);
    border: solid 1px #2f358a;
  }
`



// WEBPACK FOOTER //
// ./src/atoms/Select/index.tsx